export default __webpack_public_path__ + "static/media/Bonito24Prada.c2b3b7f7.xml";